import { CheckoutState } from '../../state';
import {
    getAreAsyncExpressCheckoutEligibleCommonRulesMet,
    isGooglePayAvailableAsExpressPaymentMethod,
} from '../expressCheckoutConditions';

export const areAsyncExpressGooglePayEligibleRulesMet = (
    state: CheckoutState,
) =>
    getAreAsyncExpressCheckoutEligibleCommonRulesMet(state) &&
    isGooglePayAvailableAsExpressPaymentMethod(state);
